import { type AppEfrConfig, appEfrConfig, efrBotPaths } from './app.efr.config';
import {
	type AppEfrAdminConfig,
	appEfrAdminConfig,
	efrAdminBotPaths,
} from './app.efrAdmin.config';
import {
	type AppEfrDromConfig,
	appEfrDromConfig,
	efrDromBotPaths,
} from './app.efrDrom.config';
import {
	type AppEfrFastConfig,
	appEfrFastConfig,
	efrFastBotPaths,
} from './app.efrFast.config';
import {
	type AppEfrT2Config,
	appEfrT2Config,
	efrT2BotPaths,
} from './app.efrT2.config';
import {
	type AppRekiConfig,
	appRekiConfig,
	rekiBotPaths,
} from './app.reki.config';
import {
	type AppWebStaticAdminConfig,
	appWebStaticAdminConfig,
	staticWebStaticAdminBotPaths,
} from './app.webStaticAdmin.config';
import type { AppHostNames } from '../appHosts';
import type { AppConfigs } from './AppConfigs/AppConfigs';

// biome-ignore lint/suspicious/noExplicitAny: <biome-ignore>
export const appConfig: { [key in AppHostNames]: AppConfigs<any> } = {
	webStaticAdmin: appWebStaticAdminConfig,
	efr: appEfrConfig,
	efrAdmin: appEfrAdminConfig,
	efrFast: appEfrFastConfig,
	efrDrom: appEfrDromConfig,
	efrT2: appEfrT2Config,
	reki: appRekiConfig,
};
export const botPaths: { [key in AppHostNames]: string[] } = {
	webStaticAdmin: staticWebStaticAdminBotPaths,
	efr: efrBotPaths,
	efrAdmin: efrAdminBotPaths,
	efrFast: efrFastBotPaths,
	efrDrom: efrDromBotPaths,
	efrT2: efrT2BotPaths,
	reki: rekiBotPaths,
};
export type AppHostConfig =
	| AppEfrConfig
	| AppRekiConfig
	| AppEfrFastConfig
	| AppEfrDromConfig
	| AppEfrT2Config
	| AppEfrAdminConfig
	| AppWebStaticAdminConfig;
